import { WhmStack, WhmTypography } from "@securitize/reactjs-whm";
import React from "react";
import { WhmCustomLoadingButton } from "../../shared/WhmCustomLoadingButton";

interface SaveFooterProps {
  isLoading: boolean;
  onSave: () => void;
  saveButtonText?: React.ReactNode;
  footer: React.ReactNode;
}

export const SaveFooter: React.FC<SaveFooterProps> = ({
  isLoading,
  onSave,
  saveButtonText,
  footer,
}) => {
  return (
    <WhmStack
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "start",
      }}
    >
      <WhmCustomLoadingButton
        onClick={onSave}
        color="primary"
        variant={"contained"}
        loading={isLoading}
        loadingPosition="start"
        sx={{
          // todo unify this styles in a styled component maybe as they are repeated
          width: { xs: "100%", lg: "fit-content" },
          minWidth: "fit-content !important",
          svg: {
            display: "block !important",
          },
          "&.MuiLoadingButton-root .MuiLoadingButton-loadingIndicator.MuiLoadingButton-loadingIndicatorCenter":
            {
              position: "absolute !important",
            },
        }}
      >
        {saveButtonText}
      </WhmCustomLoadingButton>
      <WhmTypography variant="body2">{footer}</WhmTypography>
    </WhmStack>
  );
};
